import React from 'react';
import TreatmentConsentLandingPage from './TreatmentConsentLandingPage';

export default function OrthodonticConsentFormUk() {
  return (
    <TreatmentConsentLandingPage
      title="Orthodontic Consent Form UK | Digital Dental Consent | Smile Consent"
      description="Build an orthodontic consent form for UK practices with AI-assisted drafting, digital signing, and clearer records for aligners, braces, retention, and relapse."
      canonicalUrl="https://smileconsent.co.uk/orthodontic-consent-form-uk"
      h1="Orthodontic Consent Form for UK Practices"
      treatmentName="Orthodontic consent form"
      intro="Create orthodontic consent forms for braces, aligners, retention, and treatment planning with digital signing and clearer patient records."
      risks={[
        'Expected treatment duration, limitations of treatment, and possible changes to the agreed plan.',
        'Material risks such as discomfort, root resorption, relapse, decalcification, oral hygiene issues, and breakages.',
        'Alternatives to orthodontic treatment, including doing nothing, limited treatment, or restorative options where relevant.',
        'Retention requirements, compliance expectations, and what can happen if appliances are not worn as advised.',
        'Private fees, missed appointment impact, and likely need for follow-up or long-term retention.',
      ]}
      relatedLinks={[
        { title: 'Implant consent form UK', description: 'Consent wording for implant cases', path: '/implant-consent-form-uk' },
        { title: 'Root canal consent form UK', description: 'Consent records for endodontic treatment', path: '/root-canal-consent-form-uk' },
        { title: 'AI dental consent forms', description: 'See all treatment-specific consent workflows', path: '/dental-consent-forms' },
      ]}
    />
  );
}
